/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-21 10:49:59
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-17 16:39:01
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/UploadModal/service.ts
 */
import _ from 'lodash';
import { useEffect, useState } from 'react';

import {
  createInstance,
  getResourceList,
  searchResource,
} from '@/src/request/mediaLibrary';
import { MediaFile } from '@/src/types/common/media';
import { UploadFile } from 'antd/lib/upload/interface';

const pageSize = 12;

function useService(visible, uploadType, selectAmount) {
  const [saveLoading, setSaveLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [type, setTypes] = useState('');
  const [selectedTag, setSelectedTag] = useState<any>();
  const [current, setCurrent] = useState(1);
  const [map, setMap] = useState<Map<string, string>>(new Map());

  const [preview, setPreview] = useState<MediaFile>();
  const [selected, setSelected] = useState([]);

  const [warningVisible, setWarningVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [total, setTotal] = useState(0);
  const [tags, setTags] = useState([]);
  const requestType = uploadType === 'Both' ? null : uploadType;
  useEffect(() => {
    if (visible) {
      setLoading(true);
      getResourceList((current - 1) * pageSize, pageSize, { type: requestType })
        .then((response) => {
          const total = _.get(response, 'files.totalCount', 0);
          const fileList = _.get(response, 'files.results', []) || [];
          const tags = _.get(response, 'tags', []) || [];
          setTags(tags);
          setTotal(total);
          setFileList(fileList);
        })
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [visible]);

  const handleSearchValueChange = (value: string) => {
    setSearchValue(value);
  };

  const hideWarning = () => {
    setWarningVisible(false);
  };

  const showWarning = () => {
    setWarningVisible(true);
  };

  const request_Search = async (params) => {
    try {
      setLoading(true);
      const response = await searchResource(0, params.maxCount, params.body);
      const total = _.get(response, 'totalCount');
      const files: Array<any> = _.get(response, 'results', []);
      setCurrent(1);
      setFileList(files);
      setSelected([]);
      setTotal(total);
    } catch (e) {
      console.log(e, 'err');
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setCurrent(1);
    setTags([]);
    setFileList([]);
    setTotal(0);
    setSelected([]);
    setWarningVisible(false);
  };

  const handleSearch = (value) => {
    const params = getParams(value);
    request_Search(params);
  };

  const handleClickFilter = (item, list) => {
    const params = getParams();
    if (item.name === 'Type') {
      const type =
        Array.isArray(list) && list.length !== 0 ? list[0].key : null;
      setTypes(type);
      request_Search({
        ...params,
        body: {
          ...params.body,
          type: type || null,
        },
      });
    }
    if (item.name === 'Tags') {
      const result = Array.isArray(list) && list.length !== 0 ? list[0] : null;
      setSelectedTag(result);
      request_Search({
        ...params,
        body: {
          ...params.body,
          tag: { uuid: result.key, name: result.name },
        },
      });
    }
  };

  const handleClickCard = (file: MediaFile) => {
    const list = _.cloneDeep(selected);
    const m = map;
    const index = list.indexOf(file.uuid);

    if (index === -1) {
      if (list.length >= selectAmount) {
        const l = list.length;
        const fileAmount = l + 1;
        const exceedAmount = fileAmount - selectAmount;
        list.splice(0, exceedAmount);
      }
      list.push(file.uuid);
    } else {
      list.splice(index, 1);
    }

    m.set(file.uuid, file.url);
    setMap(m);
    setSelected(list);
    setPreview(file);
  };

  const handleClearSelect = () => setSelected([]);

  const getParams = (value?: string) => {
    const _serachValue = typeof value === 'string' ? value : searchValue;
    const searchText = _serachValue ? [_serachValue] : null;
    const req = {
      type: type || null,
      searchText,
      tag: selectedTag
        ? { uuid: selectedTag.key, name: selectedTag.name }
        : null,
    };
    return {
      body: req,
      startIndex: (current - 1) * pageSize,
      maxCount: pageSize,
    };
  };

  const handleScroll = async (e) => {
    const target = e.target;
    let result = _.cloneDeep(fileList);
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      if (current * pageSize < total) {
        const params = getParams();
        setCurrent(current + 1);
        try {
          const response = await searchResource(
            current * pageSize,
            pageSize,
            params.body,
          );
          const files: Array<any> = _.get(response, 'results', []);
          result = inner_removeDuplicate(result, files);
          setFileList(result);
        } catch (e) {
          console.log(e, 'err');
        }
      }
    }
  };

  const handleDeleteType = () => {
    const params = getParams();
    setTypes('');
    request_Search({
      ...params,
      body: {
        ...params.body,
        type: null,
      },
    });
  };

  const handleDeleteTags = () => {
    const params = getParams();
    setSelectedTag(null);
    request_Search({
      ...params,
      body: {
        ...params.body,
        tag: null,
      },
    });
  };

  const handleChangeFileList = ({ file, fileList, event }) => {
    const list = _.cloneDeep(
      fileList.sort((a, b) => (a.uid ? (b.uid ? 1 : -1) : 1)),
    );
    const index = inner_FindIndexOfFileList(file, fileList);
    if (index !== -1) {
      if (file.status === 'done') {
        const res = _.get(file, 'response.payload');
        list.splice(index, 1, res);
      } else {
        list.splice(index, 1, file);
      }
      setFileList(list);
    } else {
      list.unshift(file);
      setFileList(list);
    }
  };

  const handleSubmit = async (onOk) => {
    const list = selected.map((uuid) => {
      const file = fileList.find((v) => v.uuid === uuid);
      return file;
    });
    for (const select of selected) {
      if (select) {
        try {
          setSaveLoading(true);
          //create instance Api needed when finish
          const newFile = await createInstance(select, null);
          const index = list.findIndex((l) => l.uuid === select);
          list.splice(index, 1, newFile);
        } catch (e) {
        } finally {
          setSaveLoading(false);
        }
      }
    }
    if (onOk) {
      onOk(list);
    }
  };

  const inner_FindIndexOfFileList = (
    file: UploadFile,
    fileList: Array<UploadFile>,
  ) => {
    return fileList.findIndex((f) => f.uid === file.uid);
  };

  const inner_removeDuplicate = (arr1: Array<any>, arr2: Array<any>) => {
    const obj = {};
    const result = [];
    const arr = [...arr1, ...arr2];
    arr.map((v) => {
      if (obj[v.uuid]) {
      } else {
        obj[v.uuid] = 1;
        result.push(v);
      }
    });
    return result;
  };

  return {
    map,
    selectedTag,
    type,
    selected,
    preview,
    searchValue,
    loading,
    saveLoading,
    tags,
    warningVisible,
    reset,
    hideWarning,
    showWarning,
    handleScroll,
    handleDeleteType,
    handleDeleteTags,
    handleSearch,
    handleSubmit,
    handleClickCard,
    handleClearSelect,
    handleClickFilter,
    handleChangeFileList,
    handleSearchValueChange,
    total,
    fileList,
  };
}

export default useService;
